'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var nthHookTheme = require('@narvar/nth-hook-theme');
var TrackingEventDescription = require('./TrackingEventDescription.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const ShippingHistoryEventList = styled__default["default"].ol.withConfig({
  componentId: "sc-1o82lhc-0"
})(["margin:0;list-style:none;padding:0;"]);
const ShippingHistoryEventItem = styled__default["default"].li.withConfig({
  componentId: "sc-1o82lhc-1"
})(_ref => {
  let {
    style
  } = _ref;
  return {
    margin: 0,
    ...style
  };
});
const TrackingEvents = _ref2 => {
  let {
    history,
    collapsed
  } = _ref2;
  const {
    bodytextDefaultNone,
    smalltextDefaultNone,
    smalltextEmphasisNone,
    linksNoneDefault,
    linksNoneHover
  } = nthHookTheme.useTheme();
  const historyGroupedByDate = history.reduce((acc, event) => {
    const {
      dateFormatted: [date]
    } = event;
    const eventList = acc.get(date);
    if (eventList) {
      eventList.push(event);
    } else {
      acc.set(date, [event]);
    }
    return acc;
  }, new Map());
  return /*#__PURE__*/React__default["default"].createElement(ShippingHistoryEventList, {
    "data-test": "shippingHistoryEventsContainer"
  }, [...historyGroupedByDate.entries()].map((_ref3, idx) => {
    let [date, eventList] = _ref3;
    return /*#__PURE__*/React__default["default"].createElement(ShippingHistoryEventItem, {
      key: date,
      style: {
        marginTop: idx && '1.5rem'
      }
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      style: {
        display: collapsed ? 'inline-block' : 'block',
        marginBottom: collapsed ? '0rem' : '0.5rem',
        marginRight: '0.25rem',
        ...smalltextEmphasisNone
      }
    }, /*#__PURE__*/React__default["default"].createElement("time", null, date)), /*#__PURE__*/React__default["default"].createElement(ShippingHistoryEventList, null, eventList.map(_ref4 => {
      let {
        description,
        formattedDescription,
        city,
        state,
        dateFormatted: [, time]
      } = _ref4;
      const timeAndLocation = /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("time", null, time), time && (city || state) && /*#__PURE__*/React__default["default"].createElement("span", {
        "aria-hidden": "true"
      }, "\xA0|\xA0"), /*#__PURE__*/React__default["default"].createElement("span", null, city, city && state && ', ', state));
      return /*#__PURE__*/React__default["default"].createElement(ShippingHistoryEventItem, {
        key: `${date}${time}${city ?? ''}${state ?? ''}${description ?? ''}`
      }, /*#__PURE__*/React__default["default"].createElement("span", {
        style: {
          display: collapsed ? 'inline-block' : 'block',
          ...smalltextDefaultNone
        }
      }, timeAndLocation), /*#__PURE__*/React__default["default"].createElement(TrackingEventDescription["default"], {
        formattedDescription: formattedDescription,
        description: description,
        s: bodytextDefaultNone,
        linkDefault: linksNoneDefault,
        linkHover: linksNoneHover
      }));
    })));
  }));
};
var TrackingEventsList = nthHookTheme.withThemeProvider(TrackingEvents, {
  themeTokens: ['bodytextDefaultNone', 'smalltextDefaultNone', 'smalltextEmphasisNone', 'linksNoneDefault', 'linksNoneHover']
});

exports["default"] = TrackingEventsList;
